module.exports = __webpack_public_path__ + "quotezone-ui/img/mortice-lock-white.ae361e2c.gif";